import { GuestActionDto } from "../../../../networking/data/responses/GuestActionDto";
import { GuestActionType } from "../../../../networking/data/responses/GuestActionType";
import { DiceResult } from "../../models/DiceResult";
import { Action } from "../Action";
import { AmazingWinAction } from "./diceActions/AmazingWinAction";
import { DiceComboAction } from "./diceActions/DiceComboAction";
import { DeadRollMediumCoinsAction } from "./diceActions/DeadRollMediumCoinsAction";
import { DeadRollSmallCoinsAction } from "./diceActions/DeadRollSmallCoinsAction";
import { RaidAction } from "./diceActions/raidAction/RaidAction";
import { VisitAction } from "./diceActions/visitAction/VisitAction";
import { StealAction } from "./diceActions/stealAction/StealAction";
import { DeadRollAction } from "./diceActions/DeadRollAction";
import { GiftAction } from "./diceActions/GiftAction";
import { GiftDiceRollsAction } from "./diceActions/GiftDiceRollsAction";
import { GiftShieldsAction } from "./diceActions/GiftShieldsAction";
import { GiftPiggyWheelAction } from "./diceActions/GiftPiggyWheelAction";

export class DiceRollAction implements Action {
    public readonly diceComboAction: DiceComboAction;
    public readonly diceResults: Array<DiceResult>;

    public constructor(dto: GuestActionDto) {
        if (dto == null) {
            throw new Error("You can't create DiceRollAction without providing GuestActionDto.");
        }
        if (dto.type != GuestActionType.DICE_ROLL) {
            throw new Error(`You can't create DiceRollAction from GuestActionDto with type equal to ${dto.type}.`);
        }
        if (dto.diceRollCombination == undefined || dto.diceRollCombination.length < 3) {
            throw new Error(`You can't create DiceRollAction from GuestActionDto with this diceRollCombination.`);
        }
        this.diceResults = this.convertDiceRollCombo(dto.diceRollCombination);
        this.diceComboAction = this.convertDiceRollActionToSceneIndex(dto);
    }

    private convertDiceRollCombo(diceRollCombination: Array<string>): Array<DiceResult> {
        const diceRollResults = new Array<DiceResult>();
        for (const diceRollOption of diceRollCombination) {
            let convertedDiceResult: number;
            switch (diceRollOption) {
                case "COINS":
                    convertedDiceResult = 1;
                    break;
                case "JAIL":
                    convertedDiceResult = 3;
                    break;
                case "QUESTION_MARK":
                    convertedDiceResult = 6;
                    break;
                case "RAID":
                    convertedDiceResult = 4;
                    break;
                case "STEAL":
                    convertedDiceResult = 2;
                    break;
                case "VISIT":
                    convertedDiceResult = 5;
                    break;
                default:
                    throw new Error(`Failed to convert diceRollCombination item: ${diceRollOption}. No DiceResult defined for it.`);
            }
            diceRollResults.push(convertedDiceResult);
        }
        return diceRollResults;
    }

    private convertDiceRollActionToSceneIndex(dto: GuestActionDto): DiceComboAction {
        const diceRollAction = dto.diceRollAction;
        switch (diceRollAction) {
            case "AMAZING_WIN":
                return new AmazingWinAction(dto.diceRollRewardInCoins);
            case "DEAD_ROLL":
                return new DeadRollAction();
            case "DEAD_ROLL_MEDIUM_COINS":
                return new DeadRollMediumCoinsAction(dto.diceRollRewardInCoins);
            case "DEAD_ROLL_SMALL_COINS":
                return new DeadRollSmallCoinsAction(dto.diceRollRewardInCoins);
            case "GIFT":
                if (dto.diceRollGiftRewardInDiceRolls != null) {
                    return new GiftDiceRollsAction(dto.diceRollGiftRewardInDiceRolls);
                }
                if (dto.diceRollGiftRewardInShields != null) {
                    return new GiftShieldsAction(dto.diceRollGiftRewardInShields);
                }
                return new GiftPiggyWheelAction();
            case "RAID":
                return new RaidAction(dto.diceRollRaidCard);
            case "STEAL":
                return new StealAction();
            case "UPGRADE":
                console.warn("UPGRADE scene not yet implemented.");
                return new DeadRollAction();
            case "VISIT":
                return new VisitAction(dto.diceRollVisitCard);
            default:
                throw new Error(`Failed to convert diceRollAction: ${diceRollAction}. No Action defined for it.`);
        }
    }
}
